import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "src/hooks/useAuth";
import useSessionAuth from "src/hooks/useSessionAuth";
import { getUser } from "src/redux/slices/user";
import LoadingScreen from "../LoadingScreen";
// ----------------------------------------------------------------------

SessionProtect.propTypes = {
  children: PropTypes.node,
};

function SessionProtect({ children }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authJwt);
  const { isAuthenticated } = useAuth();
  const { isLoading, isSessionAuthenticated, session } = useSessionAuth();

  //Load User data
  useEffect(() => {
    if (user == null) {
      if (window.localStorage.getItem("userId")) {
        dispatch(getUser(window.localStorage.getItem("userId")));
      } else if (session) {
        dispatch(getUser(session.idRestaurante));
      }
    }
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (session != null && isSessionAuthenticated) {
    return <>{children}</>;
  }

  if (!isSessionAuthenticated) {
    if (isAuthenticated) return <>{children}</>;

    window.open("https://takemyorder.es", "_self");

    return <></>;
  }

  return <>{children}</>;
}

export default SessionProtect;
